var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgPaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 54,
    viewBox: "0 0 247 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7113",
    "data-name": "Group 7113",
    transform: "translate(-125 -1190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    transform: "translate(125 1190)",
    fill: "#f15725",
    stroke: "rgba(33,33,33,0.1)",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 54,
    rx: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 246,
    height: 53,
    rx: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Pay_stores_smartly",
    "data-name": "Pay stores smartly",
    transform: "translate(191 1225)",
    fill: "#212121",
    fontSize: 20,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pay stores smartly")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(141 1196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2089",
    "data-name": "Rectangle 2089",
    width: 20,
    height: 16,
    rx: 2,
    transform: "translate(152 1211)",
    fill: "#ffbf69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7143",
    "data-name": "Path 7143",
    d: "M156.148,1212.451s2.756,4.5,5.656,0c.441.314.544.959,1.1,1.455a3.078,3.078,0,0,0,3.691,0c.234-.146.428-.668,1.3-1.455a3.955,3.955,0,0,0,2.6,2.071,3.084,3.084,0,0,0,2.777-1.324c.746-1.5-.832-3.646-.832-3.646l-.73-1.648s-.2-1.186-2.643-1.186h-15.09s-1.725.24-2.178,1.186a37.471,37.471,0,0,0-1.232,3.651s-.648,2.779,2.609,3.132S156.148,1212.451,156.148,1212.451Z",
    fill: "#f52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2091",
    "data-name": "Rectangle 2091",
    d: "M3.5,0h0A3.5,3.5,0,0,1,7,3.5V10a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.5A3.5,3.5,0,0,1,3.5,0Z",
    transform: "translate(158 1217)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2090",
    "data-name": "Rectangle 2090",
    d: "M3.5,0h0A3.5,3.5,0,0,1,7,3.5V10a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.5A3.5,3.5,0,0,1,3.5,0Z",
    transform: "translate(159 1217)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystore);
export default __webpack_public_path__ + "static/media/paystore.c7b4e3db54218462a5e90231afeec791.svg";
export { ForwardRef as ReactComponent };